instances = {}

function Initializer(renderer) {

  registerGlobalErrorHandler();

  this.init = function (config, user, authType, customer, showLoginDisclaimer, pension, authenticityToken) {
    $.ajaxSetup({
      data: {authenticityToken: authenticityToken},
      headers: { 'x-current-page': window.location.hash }
    })
    $(document).ajaxError(function (event, xhr, settings, error) {
      if (xhr.status === 403) location.href = '/logout'
    })

    $('#user-info').on('click', '.language-option', changeLanguageStayingAtTheSamePage)
    $('#language-change').dropdown()
    localStorage.removeItem('redirect-after-login')

    new SmartIdLogin(renderer).init()

    if (pension) {
      window.session = new Session(user, authType, customer, new Pension(pension), showLoginDisclaimer)
      new UserInfoHeader(renderer).show(session)
    }

    new Router(config, renderer)

    if (window.session && !location.hash) location.href = '#overview'
    new CookieCompliance().init()
  }

  function changeLanguageStayingAtTheSamePage(e) {
    e.preventDefault();
    window.location.href = $(e.target).attr('href') + window.location.hash
  }
}

function registerGlobalErrorHandler() {
  window.onerror = function (message, url, line, column, error) {
    const errorMessage = message + ', url: '+ url + ', line: ' + line + ', column: ' + column + ', error: ' + error;
    Logger.error(errorMessage);

    return false;
  };
}


function require(constructor) {
  if (instances[constructor]) return instances[constructor]
  var instance = new window[constructor]()
  instances[constructor] = instance
  return instance
}